
import { Vue, Component, Prop } from 'vue-property-decorator';

import RequestItemLayout from './RequestItemLayout.vue';
import RequestPlaceholder from './RequestPlaceholder.vue';
import BaseButton from '@/components/buttons/BaseButton.vue';

import { humanizeToRussian } from '@/utils/date/human';

import { ConsultationRequest } from '@/types/consultations';
import { ConsultationStatus } from '@/types/consultations'

@Component({
    components: {
        RequestItemLayout,
        RequestPlaceholder,
        BaseButton,
    }
})
export default class RequestItem extends Vue {
    @Prop({ required: true }) request!: ConsultationRequest

    get humanDuration() {
        if (this.request.duration) {   
            return humanizeToRussian(this.request.duration);
        }

        return '';
    }
    
    updateStatus(status: ConsultationStatus) {
        this.$emit('update:status', status);
    }

    selectRequest() {
        this.$emit('select');
    }

    confirmRequest() {
        this.$emit('confirm');
    }
}
